import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePoolSearch } from '../../api/pool';

export default function CandidatesList() {
  const [q, setQ] = useState('');
  const { data: people, isLoading, error } = usePoolSearch(q);

  return (
    <div className="panel">
      <h2>Candidates</h2>
      <p className="muted">Search the whole talent pool by name or email.</p>

      <input
        className="search-box"
        placeholder="Search candidates…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      {isLoading && <p className="muted">Loading…</p>}
      {error && <p className="error">Could not load candidates: {String(error)}</p>}

      {people && people.length === 0 && <p className="muted">No candidates found.</p>}
      {people && people.length > 0 && (
        <table className="table">
          <thead><tr><th>Name</th><th>Email</th><th className="center">Applications</th><th>Compensation</th></tr></thead>
          <tbody>
            {people.map((p) => (
              <tr key={p.id}>
                <td><Link to={`/candidates/${p.id}`}>{p.fullName}</Link></td>
                <td className="muted small">{p.email}</td>
                <td className="center">{p.applicationCount}</td>
                <td className="muted small">{p.compensation ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
